import React, {Component} from 'react';
import Modal from '../UI/Modal';
import {Icon} from '../UI/Icon';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";

class DropdownField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            data: {
                title: null,
                items: []
            }
        };
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                data: value
            });
        }
    }

    save() {
        this.props.input.onChange(this.state.data);

        this.setState({
            modal: false
        });
    }

    showModal() {
        this.setState({
            modal: true
        });
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    clear() {
        const {input} = this.props;

        input.onChange(null);

        this.setState({
            data: {
                title: null,
                items: []
            }
        });
    }

    render() {
        const {modal, data} = this.state;
        const {input, label, meta: {touched, error}} = this.props;

        return (
            <div>
                {label &&
                <label>{label}</label>
                }
                <Modal
                    showModal={modal}
                    onClose={() => {
                        this.hideModal();
                    }}
                    title="Add a dropdown"
                    icon="bars"
                    modalFooter={
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary
                                small
                                title="Save"
                                icon={"save"}
                                onClick={(e) => {
                                    e.preventDefault();

                                    this.save();
                                }}
                            />
                        </div>
                    }
                >
                    <div>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-text': true
                            })}
                        >
                            <label htmlFor="link_title">Dropdown title</label>
                            <input
                                type="text"
                                id="dropdown_title"
                                name="dropdown_title"
                                onChange={(e) => {
                                    this.setState({
                                        data: {
                                            ...data,
                                            title: e.target.value
                                        }
                                    });
                                }}
                            />
                        </div>
                        {data.items && data.items.length > 0 &&
                        <div>
                            <h4>Items</h4>
                            {data.items.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <div
                                            className={classNamesPrefixed({
                                                'form-item': true,
                                                'form-group': true
                                            })}
                                        >
                                            <input
                                                type="text"
                                                id="dropdown_items"
                                                name="dropdown_items[]"
                                                defaultValue={item}
                                                onChange={(e) => {
                                                    e.preventDefault();

                                                    const items = this.state.data.items ? this.state.data.items : [];

                                                    items[index] = e.target.value;

                                                    this.setState({
                                                        data: {
                                                            ...data,
                                                            items: items
                                                        }
                                                    });
                                                }}
                                            />
                                            <BtnPrimary
                                                onClick={(e) => {
                                                    e.preventDefault();

                                                    const items = this.state.data.items ? this.state.data.items : [];

                                                    delete items[index];

                                                    this.setState({
                                                        data: {
                                                            ...data,
                                                            items: items
                                                        }
                                                    });
                                                }}
                                            >
                                                Remove
                                            </BtnPrimary>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        }
                        <h4>Add item</h4>
                        <div
                            className={classNamesPrefixed({
                                'form-item': true,
                                'form-group': true
                            })}
                        >
                            <input
                                ref={(ref) => {
                                    this.dropdownItem = ref;
                                }}
                                type="text"
                                id="dropdown_item"
                                name="dropdown_item"
                            />
                            <BtnSecondary
                                onClick={(e) => {
                                    e.preventDefault();

                                    const items = this.state.data.items ? this.state.data.items : [];

                                    items.push(this.dropdownItem.value);

                                    this.dropdownItem.value = '';

                                    this.setState({
                                        data: {
                                            ...data,
                                            items: items
                                        }
                                    });
                                }}
                            >
                                Add
                            </BtnSecondary>
                        </div>
                        <br/>
                    </div>
                </Modal>
                <p>
                    <i
                        className={classNamesPrefixed({
                            'grey-color': true
                        })}
                    >Create a dropdown.</i>
                </p>
                {input.value === '' ? (
                    <div
                        className={classNamesPrefixed({
                            'form-actions': true
                        })}
                    >
                        <BtnSecondary
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();

                                this.showModal();
                            }}
                        >
                            Dropdown
                        </BtnSecondary>
                    </div>
                ) : (
                    <div>
                        <p><Icon name="bars"/> {data.title}</p>
                        <ul
                            className={classNamesPrefixed({
                                'grey-color': true
                            })}
                        >
                            {data.items.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <i>{item}</i>
                                    </li>
                                );
                            })}
                        </ul>
                        <div
                            className={classNamesPrefixed({
                                'form-actions': true
                            })}
                        >
                            <BtnPrimary onClick={this.clear.bind(this)}>Remove</BtnPrimary>
                        </div>
                    </div>
                )}
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
            </div>
        );
    }
}

export default DropdownField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/DropdownField.js